import { toast } from "react-toastify";

export const validateActivitySearch = ({ values, showToast = true }) => {
  const error_msgs = [];
  if (!values.destinationObj.destination_code.length) {
    error_msgs.push(["destination", "Please select a Destination."]);
  }
  if (!values.datesArray[0]) {
    error_msgs.push(["dates", "Please select dates"]);
  }

  if (error_msgs.length && showToast) {
    toast.warning(
      <ul>
        {error_msgs.map((msg, idx) => (
          <li key={idx}>{msg[1]}</li>
        ))}
      </ul>,
      { duration: 5000 }
    );
  }
  return error_msgs;
};
